import React from 'react';
import { HOLES, TEES, DISTANCES, TOTAL_PAR, totalFor } from './courseData';
import { TeeDot } from './TeeSelector';

const cell = 'py-2.5 px-2 sm:px-3 text-center font-montserrat text-sm tabular-nums';

const ScoreCard = ({ open, hole, tee, onSelectHole }) => {
  const colClass = (n) => (hole === n ? 'bg-[#c9a962]/10' : '');
  return (
    <div
      id="scorecard-table"
      className="grid transition-[grid-template-rows] duration-500 ease-out"
      style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
      data-testid="scorecard"
      aria-hidden={!open}
    >
      <div className="overflow-hidden">
        <div className="mt-4 border border-[#c9a962]/15 rounded-2xl overflow-hidden bg-white/[0.02]">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px]" data-testid="scorecard-table">
              <thead>
                <tr className="border-b border-[#c9a962]/15">
                  <th className="sticky left-0 bg-[#122a1e] py-2.5 pl-5 pr-3 text-left font-montserrat text-white/45 text-[10px] tracking-[0.2em] uppercase">Départ</th>
                  {HOLES.map((h) => (
                    <th key={h.number} className={`${cell} ${colClass(h.number)}`}>
                      <button
                        type="button"
                        onClick={() => onSelectHole(h.number)}
                        tabIndex={open ? 0 : -1}
                        data-testid={`scorecard-hole-${h.number}`}
                        className={`font-medium rounded px-1.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c9a962] ${hole === h.number ? 'text-[#0f2419] bg-[#c9a962]' : 'text-[#c9a962] hover:text-white'}`}
                      >
                        {h.number}
                      </button>
                    </th>
                  ))}
                  <th className={`${cell} font-montserrat text-white/45 text-[10px] tracking-[0.2em] uppercase bg-[#c9a962]/10`}>Total</th>
                </tr>
              </thead>
              <tbody>
                {TEES.map((t) => {
                  const on = t.id === tee;
                  return (
                    <tr key={t.id} className={`border-b border-white/5 transition-colors ${on ? 'bg-[#c9a962]/[0.08]' : ''}`} data-testid={`scorecard-row-${t.id}`}>
                      <td className={`sticky left-0 py-2.5 pl-5 pr-3 ${on ? 'bg-[#1a3c2a]' : 'bg-[#122a1e]'}`}>
                        <span className="flex items-center gap-2.5 font-montserrat text-xs text-white/80">
                          <TeeDot color={t.color} size="w-2.5 h-2.5" />{t.label}
                        </span>
                      </td>
                      {HOLES.map((h) => (
                        <td key={h.number} className={`${cell} ${colClass(h.number)} ${on ? 'text-white font-medium' : 'text-white/60'}`}>
                          {DISTANCES[t.id][h.number - 1]}
                        </td>
                      ))}
                      <td className={`${cell} bg-[#c9a962]/10 font-semibold ${on ? 'text-[#c9a962]' : 'text-white/70'}`}>
                        {totalFor(t.id).toLocaleString('fr-FR')} m
                      </td>
                    </tr>
                  );
                })}
                <tr className="border-b border-white/5">
                  <td className="sticky left-0 bg-[#122a1e] py-2.5 pl-5 pr-3 font-montserrat text-[10px] tracking-[0.2em] uppercase text-white/45">Par</td>
                  {HOLES.map((h) => <td key={h.number} className={`${cell} text-white/70 ${colClass(h.number)}`}>{h.par}</td>)}
                  <td className={`${cell} bg-[#c9a962]/10 text-white/70 font-semibold`}>{TOTAL_PAR}</td>
                </tr>
                <tr>
                  <td className="sticky left-0 bg-[#122a1e] py-2.5 pl-5 pr-3 font-montserrat text-[10px] tracking-[0.2em] uppercase text-white/45">Hcp</td>
                  {HOLES.map((h) => <td key={h.number} className={`${cell} text-white/70 ${colClass(h.number)}`}>{h.hcp}</td>)}
                  <td className="bg-[#c9a962]/10" />
                </tr>
              </tbody>
            </table>
          </div>
          <p className="font-montserrat text-white/35 text-[11px] leading-relaxed px-5 py-3 border-t border-[#c9a962]/10">
            Tracés reconstitués à partir du master plan et reportés sur la vue aérienne. Distances, par et handicaps issus de la carte de score du projet — architecture Nicolas Duchateau, parcours Alain Cnrjac.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScoreCard;
